import {hideLoadingFunction, showLoading} from "Core/helpers/loading";
import {ioJsonAction} from "Core/store/actions/io";

/**
 * Archive studies
 * 
 * @param {function} [abortCallback=(abortController)=>{}] - Callback function that will receive AbortController as an
 * argument.
 * @param {string[]} studyIds - List of study IDs to archive.
 * @return {function(*): *}
 */
export const archiveStudiesAction = (abortCallback, studyIds) => dispatch => {
	const loading = showLoading("#study-archive-confirm-dialog .dialog-content-component > .buttons");
	return ioJsonAction(
		abortCallback,
		'defaultAuthorizedApi',
		'study/archive-studies',
		{ids: studyIds},
		hideLoadingFunction(loading),
	)(dispatch);
};